import PeriodSelector from "components/PeriodSelector";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import React from "react";

const ToolbarWithHeading = (props: React.PropsWithChildren<{}>) => {
  return (
    <ToolbarContainer>
      <SplitView partCnt={2}>
        <ToolbarTitle>{props.children}</ToolbarTitle>
        <Right>
          <PeriodSelector />
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default ToolbarWithHeading;
